export const appRoot = document.getElementById('root')
export const notificationRoot = document.getElementById('notification-root')
